export class EmployeeEdit {
  constructor(data = {}) {
    this.idEmpleado = data.idEmpleado || 0;
    this.noEmpleado = data.noEmpleado || 0;
    this.nombre = data.nombre || "";
    this.apellidoPaterno = data.apellidoPaterno || "";
    this.apellidoMaterno = data.apellidoMaterno || "";
    this.correo = data.correo || "";
    this.telefono = data.telefono || "";
    this.idUbicacion = data.idUbicacion || 0;
    this.nombreUbicacion = data.nombreUbicacion || "";
    this.idPais = data.idPais || 0;
    this.ciudad = data.ciudad || "";
    this.estado = data.estado || "";
    this.calle = data.calle || "";
    this.colonia = data.colonia || "";
    this.codigoPostal = data.codigoPostal || "";
    this.numeroExterior = data.numeroExterior || 0;
    this.numeroInterior = data.numeroInterior || 0;
    this.fechaIngreso = data.fechaIngreso || null;
    this.base64 = data.base64 || "";
    this.extension = data.extension || "";
    this.foto = data.foto || "";
    this.apodos = data.apodos || "";
    this.usuarioId = data.usuarioId || "";
    this.activo = data.activo || true;
  }
}
